import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import templateHtml from 'templates/navigation/SensorsPopupMenuItemView.html';
import moment from 'moment';
import Personalizer from 'personalizer';

export default Backbone.View.extend({
    template: _.template(templateHtml),
    className: 'header-nav-menu-section',

    initialize: function(args) {
        this.sensor = args.sensor;
        this.userPreferences = args.userPreferences;
        this.currentRegisteredDevices = args.currentRegisteredDevices;
    },

    getNamesBasedOnSensorTypeMapping: function() {
        switch (this.sensor.sensorType) {
            case 'BIKE_LIGHT_MAIN':
            case 'BIKE_LIGHT_SHARED':
                return {
                    imageUrl: 'icon_sensor_lights_dark.png',
                    translationKey: 'sensor_lights'
                };
            case 'BIKE_SPEED_CADENCE':
                return {
                    imageUrl: 'icon_sensor_bike_cadence_dark.png',
                    translationKey: 'sensor_bike_speed_cadence'
                };
            case 'BIKE_CADENCE':
                return {
                    imageUrl: 'icon_sensor_bike_cadence_dark.png',
                    translationKey: 'sensor_bike_cadence'
                };
            case 'CONTROL':
            case 'CONTROLS':
                return {
                    imageUrl: 'icon_sensor_edge_remote_dark.png',
                    translationKey: 'sensor_edge_remote'
                };
            case 'HEART_RATE':
                return {
                    imageUrl: 'icon_sensor_heart_rate_dark.png',
                    translationKey: 'sensor_heart_rate_monitor'
                };
            case 'CONTROL_HUB':
            case 'SHIFTING':
                return {
                    imageUrl: 'icon_sensor_shifting_dark.png',
                    translationKey: 'sensor_shifting'
                };
            case 'RUN':
                return {
                    imageUrl: 'icon_sensor_footpod_dark.png',
                    translationKey: 'sensor_rd_pod'
                };
            case 'FOOTPOD':
            case 'STRIDE_SPEED_DISTANCE':
                return {
                    imageUrl: 'icon_sensor_footpod_dark.png',
                    translationKey: 'sensor_footpod'
                };
            case 'BIKE_RADAR':
                return {
                    imageUrl: 'icon_sensor_radar_dark.png',
                    translationKey: 'sensor_radar'
                };
            case 'FITNESS_EQUIPMENT':
                return {
                    imageUrl: 'icon_sensor_smart_trainer_dark.png',
                    translationKey: 'sensor_smart_trainer'
                };
            case 'ENVIRONMENT_SENSOR_LEGACY':
            case 'ENV_SENSOR':
                return {
                    imageUrl: 'icon_sensor_temperature_dark.png',
                    translationKey: 'sensor_temperature'
                };
            case 'EXD':
                return {
                    imageUrl: 'icon_sensor_varia_dark.png',
                    translationKey: 'sensor_varia'
                };
            case 'BIKE_POWER':
                return {
                    imageUrl: 'icon_sensor_power_dark.png',
                    translationKey: 'sensor_power'
                };
            case 'BIKE_SPEED':
                return {
                    imageUrl: 'icon_sensor_speed_dark.png',
                    translationKey: 'sensor_speed'
                };
            case 'MULTI_SPORT_SPEED_DISTANCE':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_speed_distance'
                };
            case 'BLOOD_PRESSURE':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_blood_pressure_monitor'
                };
            case 'GEOCACHE_NODE':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_geocache'
                };
            case 'LIGHT_ELECTRIC_VEHICLE':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_ebike'
                };
            case 'ACTIVITY_MONITOR':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_activity_monitor'
                };
            case 'GLUCOSE_MONITOR':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_glucose_monitor'
                };
            case 'RACQUET':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_racquet'
                };
            case 'MUSCLE_OXYGEN':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_muscle_oxygen'
                };
            case 'BIKE_AERO':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_aero'
                };
            case 'WEIGHT_SCALE':
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_scale'
                };
            default:
                return {
                    imageUrl: 'icon_sensor_other_dark.png',
                    translationKey: 'sensor_other'
                };
        }
    },

    getLastSyncDate: function() {
        let lastConnectedDate = this.sensor && this.sensor.lastConnected ? this.sensor.lastConnected : null;

        if (lastConnectedDate) {
            //the received timestamp from the API is utc - convert to local
            lastConnectedDate = moment
                .utc(lastConnectedDate)
                .local()
                .format();
            let isToday = moment().isSame(moment(lastConnectedDate), 'day');
            let isYesterday = moment()
                .subtract(1, 'day')
                .isSame(lastConnectedDate, 'day');
            let dateFormat = Personalizer.getDateFormatKey();
            let userPreferenceTimeFormat =
                (this.userPreferences &&
                    this.userPreferences.get('timeFormat') &&
                    this.userPreferences.get('timeFormat').displayFormat) ||
                'h:mm a';
            let syncTimeByUserSetting = moment(lastConnectedDate).format(userPreferenceTimeFormat);

            if (isToday) {
                return `${Localizer.localize('today')} @ ${syncTimeByUserSetting}`;
            } else if (isYesterday) {
                return `${Localizer.localize('yesterday')} @ ${syncTimeByUserSetting}`;
            }

            return new moment(lastConnectedDate).format(dateFormat);
        }
        return null;
    },

    getBatteryStatusLabel: function() {
        let status = 'not_available';
        const batteryStatus = this.sensor.batteryStatus;

        if (batteryStatus && batteryStatus !== 'UNKNOWN' && batteryStatus !== 'INVALID') {
            status = batteryStatus.toLowerCase();
        }

        return `battery_${status}`;
    },

    getSensorInRegisteredDevices: function() {
        return this.currentRegisteredDevices.find((device) => device.partNumber === this.sensor.partNumber);
    },

    getAlternativeImageUrl: function() {
        if (this.sensor.sensorType) {
            var sensorTypeImage = this.getNamesBasedOnSensorTypeMapping();

            return `/images/devices/sensors/${sensorTypeImage.imageUrl}`;
        }
        return '/images/devices/sensors/icon_sensor_other_dark.png';
    },

    getDeviceName: function() {
        if (this.sensor) {
            if (this.sensor.deviceName) {
                return this.sensor.deviceName;
            } else {
                var sensorName = this.getNamesBasedOnSensorTypeMapping();
                var serialNumber = this.sensor.serialNumber ? this.sensor.serialNumber : '';
                return Localizer.localize(sensorName.translationKey, serialNumber);
            }
        }
    },

    render: function() {
        let isAboveLow = false;
        let lastConnectedDate = this.getLastSyncDate();

        const sensorInfo = this.getSensorInRegisteredDevices();

        const isRechargeableSensorCapable = sensorInfo?.rechargeableSensorCapable;

        let batteryStatusLabel, batteryStatusIconClass, batteryLevel;

        if (isRechargeableSensorCapable && this.sensor.batteryLevel) {
            batteryLevel = this.sensor.batteryLevel + '%';
        } else {
            batteryStatusLabel = this.getBatteryStatusLabel();
            let batteryIconStatusLabel = batteryStatusLabel;
            if (
                batteryIconStatusLabel === 'battery_good' ||
                batteryIconStatusLabel === 'battery_ok' ||
                batteryStatusLabel === 'battery_new'
            ) {
                //the good and ok battery image was changed to the same as new - the text is still different -
                //this is because some devices are missing battery levels and whould never show full battery on battery change
                batteryIconStatusLabel = 'battery_new';
                isAboveLow = true;
            }
            batteryStatusIconClass = `icon_${batteryIconStatusLabel}_black.svg`;
        }

        let sensorImageUrl = this.sensor.imageUrl ? this.sensor.imageUrl : this.getAlternativeImageUrl();
        let deviceName = this.getDeviceName();

        this.$el.html(
            this.template({
                Localizer,
                batteryStatusLabel,
                batteryLevel,
                lastConnectedDate,
                sensorImageUrl,
                deviceName,
                batteryStatusIconClass,
                isAboveLow
            })
        );

        return this;
    }
});
